import { render, staticRenderFns } from "./StripeSubscription.vue?vue&type=template&id=10508930"
import script from "./StripeSubscription.vue?vue&type=script&lang=js"
export * from "./StripeSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports